import $ from "jquery";
import '@lottiefiles/lottie-player';
import {create} from '@lottiefiles/lottie-interactivity';

$(document).ready(function () {
  const lottie_saw = document.getElementById('lottie_sawParts')
  if (lottie_saw) {
    create({
      mode: 'scroll',
      player: '#lottie_sawParts',
      actions: [
        {
          visibility: [0.1, 0.7],
          type: "seek",
          frames: [0, 180]
        },
      ],
    });
  }
});
